import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashRegisterService {
  private apiUrl = environment.BASE_LA;

  constructor(private http: HttpClient) { }

  getCashRegistersByShop(shopCode: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/shop/cash-registers/${shopCode}`);
  }

  getCashRegisterByNumber(shopCode: string, cashRegisterNumber: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/shop/cash-register/${shopCode}/${cashRegisterNumber}`);
  }

  createCashRegister(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/shop/cash-register`, data);
  }

  updateCashRegister(id: string, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/shop/cash-register/${id}`, data);
  }

  deleteCashRegister(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/shop/cash-register/${id}`);
  }
}
